module.exports = __webpack_public_path__ + "img/twint-old.86a53d28.png";